import { render, staticRenderFns } from "./Explain.vue?vue&type=template&id=6f324a70&scoped=true"
import script from "./Explain.vue?vue&type=script&lang=js"
export * from "./Explain.vue?vue&type=script&lang=js"
import style0 from "./Explain.vue?vue&type=style&index=0&id=6f324a70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f324a70",
  null
  
)

export default component.exports